import BaseHandler from "../BaseHandler";
import { GroupAvatarAdd, GroupAvatarAddResponse } from "../../proto/GroupAvatarAdd_pb";
import { updateGroupAvatar } from "../../store/rooms/actions";
import store from "../../store";

export default class HandleGroupAddAvatarResponse extends BaseHandler<GroupAvatarAddResponse, GroupAvatarAdd> {
  handle() {
    const groupAddAvatarLinkResponse = this.response.toObject();

    if (groupAddAvatarLinkResponse !== undefined) {
      store.dispatch(updateGroupAvatar(groupAddAvatarLinkResponse));
    }
  }
}
